module.exports = __webpack_public_path__ + "6a808dcc04099eaa3c5f7f3b27b2f0b6.pdf";